import React from "react";
import { Check, AlertCircle } from "lucide-react";

interface BalanceStatusProps {
  isPaid: boolean;
  dueAmount: number;
  balance: number;
  customerName?: string;
}

export const BalanceStatus: React.FC<BalanceStatusProps> = ({
  isPaid,
  dueAmount,
  balance,
  customerName,
}) => {
  return (
    <div
      className={`flex items-center justify-between px-3 py-3 rounded-xl border ${
        isPaid
          ? "bg-green-50/50 border-green-200/50"
          : "bg-amber-50/50 border-amber-200/50"
      }`}
    >
      <div className="flex items-center gap-2.5">
        {isPaid ? (
          <Check className="w-5 h-5 text-green-600" />
        ) : (
          <AlertCircle className="w-5 h-5 text-amber-600" />
        )}
        <div>
          <p
            className={`text-[9px] font-bold uppercase tracking-wider ${
              isPaid ? "text-green-700" : "text-amber-700"
            }`}
          >
            {isPaid ? "Change Balance" : "Outstanding Credit / Due"}
          </p>
          <p
            className={`text-[11px] mt-0.5 leading-tight ${
              isPaid ? "text-green-700/80" : "text-amber-700/80"
            }`}
          >
            {isPaid
              ? "Return balance to customer"
              : customerName
                ? `LKR ${dueAmount.toLocaleString()} will be charged as credit to ${customerName}.`
                : "A customer must be selected to log outstanding due."}
          </p>
        </div>
      </div>
      <span
        className={`text-sm font-black shrink-0 ${
          isPaid ? "text-green-700" : "text-amber-700"
        }`}
      >
        LKR {isPaid ? balance.toLocaleString() : dueAmount.toLocaleString()}
      </span>
    </div>
  );
};
